import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import TitleAndInputBox from "../../../../common/dataView/TitleAndInputBox";
import {useTranslation} from "react-i18next";
import DataUtils from "../../../common/utils/DataUtils";
import _ from "lodash";
import DataCompareService from "../../../../../services/DataCompareService";
import UserService from "../../../../../services/UserService";
import axios from "axios";
import SimpleButton from "../../../common/buttons/SimpleButton";
import ConfirmModal from "../../../../common/confirm/ConfirmModal";
import ButtonWithSpinner from "../../../common/buttons/ButtonWithSpinner";
import LanguageInput from "../../../../../language/component/LanguageInput";
import {toast} from "react-toastify";
import ToastAlertView from "../../../../common/alert/ToastAlertView";
import DeleteConfirmModal from "../../../../common/deleteComponents/DeleteConfirmModal";
import DeleteService from "../../../../../services/DeleteService";
import {useParams} from "react-router-dom";
import useAxios from "../../../../../customHooks/useAxios";

const MenuCategoryContainer = styled.div`
  width: 100%;
  border: none;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  margin-bottom: 15px;
  -webkit-box-shadow: 0px 0px 3px 0px rgba(105,105,105,0.36);
  -moz-box-shadow: 0px 0px 3px 0px rgba(105,105,105,0.36);
  box-shadow: 0px 0px 3px 0px rgba(105,105,105,0.36);
`;

const MessageNotExist = styled.span`
  font-size: 14px;
  color: #c2c2c2;
`;

const MessageExist = styled.span`
  font-size: 14px;
  color: #6bbbed;
`;

const MenuCategoryItemView = ({ menuCategoryInfo,
                                  updateRequestBody,
                                  updateIsValidMap,
                                  updateIsValid,
                                  updateIsEdited,
                                  requestBody,
                                  isValidMap,
                                  isValid,
                                  isEdited,
                                  refreshCategoryList,
                                  onDeleteCallback,
                                  currentLang,
                                  isHighlightOn }) => {

    /** New : axios hook */
    const { isAxiosLoading, axiosCall } = useAxios();

    const { t } = useTranslation();

    /* states */
    const [isLoading, setIsLoading] = useState(false);

    /* confirmation */
    const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);

    /* save */
    const putMenuCategory = async () => {
        try {
            await setIsLoading(true);
            await axiosCall(
                "PUT",
                '/franchise-menu-category/franchise/:1/category/:2',
                menuCategoryInfo['franchiseMenuCategoryLookupFranchiseId'] ?
                    [menuCategoryInfo['franchiseMenuCategoryLookupFranchiseId'], menuCategoryInfo["franchiseMenuCategoryLookupId"]]
                    :
                    ["default", menuCategoryInfo["franchiseMenuCategoryLookupId"]],
                requestBody,
                null,
                {},
                "default"
            );
            /* success */
            await setIsLoading(false);
            toast.success(<ToastAlertView message={t("message.saved")} />);
            refreshCategoryList();
        } catch (e) {
            console.log(e);
            await setIsLoading(false);
            toast.error(<ToastAlertView message={t("message.failed")} />);
        }
    };

    const handleRequestBodyInput = async (key, value) => {
        await updateRequestBody(key, value);
        let fixedRequestBody = {};
        fixedRequestBody["franchiseMenuCategoryName"] = menuCategoryInfo["franchiseMenuCategoryLookupName"];
        fixedRequestBody["franchiseMenuCategoryName1"] = menuCategoryInfo["franchiseMenuCategoryLookupName1"];
        fixedRequestBody["franchiseMenuCategoryName2"] = menuCategoryInfo["franchiseMenuCategoryLookupName2"];
        fixedRequestBody["franchiseMenuCategoryName3"] = menuCategoryInfo["franchiseMenuCategoryLookupName3"];
        fixedRequestBody["franchiseMenuCategoryName4"] = menuCategoryInfo["franchiseMenuCategoryLookupName4"];
        fixedRequestBody["franchiseMenuCategoryName5"] = menuCategoryInfo["franchiseMenuCategoryLookupName5"];
        updateIsEdited(!_.isEqual(requestBody, fixedRequestBody));
    };

    const handleIsValidMapChange = async (key, value) => {
        await updateIsValidMap(key, value);
        updateIsValid(DataCompareService.checkIsAllTrue(isValidMap));
    };

    return (
        <MenuCategoryContainer>
            <Container fluid>
                <Row>
                    <LanguageInput
                        type={"text"}
                        title={t("menu.franchiseMenu.menuCategoryEdit.detail.categoryName") + ` (${t("language.callName." + currentLang)})`}
                        dataKeyTranslationPath={"language.dataKey.menu.category.name"}
                        valueMap={requestBody}
                        updateValueMap={handleRequestBodyInput}
                        isValidMap={isValidMap}
                        updateIsValidMap={handleIsValidMapChange}
                        isForEdit={true}
                        currentLang={currentLang}
                        isHighlightOn={isHighlightOn}
                    />
                </Row>
                <Row
                    style={{
                        marginTop: '5px'
                    }}
                >
                    <div
                        style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                        }}
                    >
                        {/* menu count message */}
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            {
                                (menuCategoryInfo['menuCount'] > 0) ?
                                    <MessageExist>
                                        {
                                            menuCategoryInfo['menuCount']
                                            + t("menu.franchiseMenu.menuCategoryEdit.message.menuCount")
                                        }
                                    </MessageExist>
                                    :
                                    <MessageNotExist>
                                        {t("menu.franchiseMenu.menuCategoryEdit.message.noMenu")}
                                    </MessageNotExist>
                            }
                        </div>
                        {/* delete button */}
                        <div
                            style={{
                                width: '100px',
                                marginLeft: 'auto'
                            }}
                        >
                            <SimpleButton
                                onClickCallback={() => setIsDeleteConfirmOpen(true)}
                                isEnabled={!(menuCategoryInfo['menuCount'] > 0)}
                                label={t("button.delete")}
                                borderColor={"#ff4d4d"}
                                buttonColor={"#ff4d4d"}
                                buttonHoverColor={"#ffcccc"}
                                buttonDisabledColor={"#ebebeb"}
                            />
                        </div>
                        {/* save button */}
                        <div
                            style={{
                                width: '100px',
                                marginLeft: '10px'
                            }}
                        >
                            {
                                isLoading ?
                                    <ButtonWithSpinner
                                        buttonColor={"#fc7242"}
                                    />
                                    :
                                    <SimpleButton
                                        onClickCallback={() => putMenuCategory()}
                                        isEnabled={isEdited && isValid}
                                        label={t("button.save")}
                                        borderColor={"#fc7242"}
                                        buttonColor={"#fc7242"}
                                        buttonHoverColor={"#fff1ec"}
                                        buttonDisabledColor={"#c2c2c2"}
                                    />
                            }
                        </div>
                    </div>
                </Row>
            </Container>
            {/* confirmation modal */}
            <DeleteConfirmModal
                isOpen={isDeleteConfirmOpen}
                setIsOpen={setIsDeleteConfirmOpen}
                isDelayed={false}
                confirmMessage={t("language.message.deletion.confirmation", { entityName: menuCategoryInfo[t("language.dataKey.menu.category.name")] })}
                entity={DeleteService.ValidEntities.MENU_CATEGORY}
                entityName={menuCategoryInfo[t("language.dataKey.menu.category.name")]}
                id={
                    `franchise-menu-category`
                    + `/franchise/${menuCategoryInfo['franchiseMenuCategoryLookupFranchiseId'] ? menuCategoryInfo['franchiseMenuCategoryLookupFranchiseId'] : "default"}`
                    + `/category/${menuCategoryInfo["franchiseMenuCategoryLookupId"]}`
                }
                onDeleteSuccess={async () => await refreshCategoryList()}
            />
            {/*<ConfirmModal*/}
            {/*    isOpen={isDeleteConfirmOpen}*/}
            {/*    setIsOpen={setIsDeleteConfirmOpen}*/}
            {/*    title={t("menu.franchiseMenu.menuCategoryEdit.message.sureToDelete")}*/}
            {/*    confirmLabel={t("button.yes")}*/}
            {/*    rejectLabel={t("button.no")}*/}
            {/*    onConfirm={onDeleteCallback}*/}
            {/*    onReject={() => {}}*/}
            {/*/>*/}
        </MenuCategoryContainer>
    );
};

export default MenuCategoryItemView;